// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"925000b0","774":"8dabf402"}[chunkId] + ".chunk.css";
};